"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormErrors = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
/**
 * Simple component capable of rendering the form's errors
 * passed as an array of strings.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let FormErrors = class FormErrors extends vue_property_decorator_1.Vue {
};
__decorate([
    vue_property_decorator_1.Prop({ type: Array, required: false, default: () => [] }),
    __metadata("design:type", Array)
], FormErrors.prototype, "errors", void 0);
FormErrors = __decorate([
    vue_property_decorator_1.Component({
        name: 'FormErrors',
        template: `
    <ul class="list-unstyled text-danger font-weight-bold">
      <li v-for="error in errors" :key="error">
        {{ error }}
      </li>
    </ul>
  `
    })
], FormErrors);
exports.FormErrors = FormErrors;
//# sourceMappingURL=FormErrors.js.map